<style>

    .popup-content{
        height: auto;
        width: 500px;
    }
    
    .popup-left{
        width: 50%;
        display: inline-block;
    }
    
    .popup-right{
        width: 50%;
        display: inline-block;
        vertical-align: top;
        margin-top: 1%;
    }
    
    .popup-picture{
        width: 70%;
        border-radius: 5%;
    }
    .popup-text-post{
        font-size: 2em;
        font-weight: bold;
        text-align: justify;
    }
    
    .popup-text-description{
        margin-top: 6%;
        text-align: justify;
    }

    /*-------------------------------------
    ---------------------------------------
                MOBILE VIEW
    ---------------------------------------
    ---------------------------------------*/

    @media only screen and (max-width: 600px){
        .popup-content{
            height: auto;
            width: 250px;
        } 
        .popup-picture{
            width: 100%;
            border-radius: 5%;
        }

        .popup-left{
            width: 100%;
            display: inline-block;
        }

        .popup-right{
            width: 100%;
            display: inline-block;
            vertical-align: top;
            margin-top: 1%;
        }
    }
        
    </style>
    
    <div class="popup-content">
        <div class="popup-left">
            <img class ="popup-picture" src="../../assets/images/uc3m.png">
        </div>
        <div class="popup-right">
            <span class="popup-text-post">Profesor particular</span>
            <br>
            <p class="popup-text-description">Enseñanza de materías STEM</p>
        </div>
    
        
        
    </div>